export default {
  orgId: process.env.VUE_APP_CHAT_ORGID ?? "00DWe000001HXF7",
  deploymentId: process.env.VUE_APP_CHAT_DEPLOYMENTID ?? "Nexcess_Support_Portal_MIAW",
  communityURL:
    process.env.VUE_APP_CHAT_COMMUNITYURL ??
    "https://liquidweb--developer.sandbox.my.site.com/ESWNexcessSupportPortal1738620000146",
  scrt2URL:
    process.env.VUE_APP_CHAT_SCRT2URL ??
    "https://liquidweb--developer.sandbox.my.salesforce-scrt.com",
  settings: {
    language: "en_US",
    chatButtonPosition: "32px,32px",
  },

  // Messaging Service for Web script location
  messagingScriptURL:
    process.env.VUE_APP_CHAT_MSGSCRIPTURL ??
    "https://liquidweb--developer.sandbox.my.site.com/ESWNexcessSupportPortal1738620000146/assets/js/bootstrap.min.js",

  // Registrable domain where store cookies
  storageDomain: process.env.VUE_APP_CHAT_STORAGEDOMAIN ?? "nexcess.net",

  // When the chat button is clicked, the amount of time
  // to wait for the script to report "ready" before
  // assuming something went wrong. Not necessarily a hard
  // failure. The user could just have a slow connection.
  chatStartTimeout: process.env.VUE_APP_CHAT_TIMEOUT ?? 30000,

  // Analytics configuration
  analyticsMode: process.env.VUE_APP_CHAT_ANALYTICSMODE ?? "dataLayer",

  // The context for web analytics action names (context:object_action)
  analyticsActionContext: process.env.VUE_APP_CHAT_ANALYTICSCONTEXT ?? "nx",

  // Disable if Google Analytics is not implemented.
  useGoogleAnalytics: process.env.VUE_APP_CHAT_ENABLEGA ?? true,

  // Amount of time to wait for Google Analytics to return
  // a tracker object. The script may block for up to this
  // duration in some situations, such as when an ad blocker
  // has replaced window.ga with a no-op function.
  googleAnalyticsTrackerTimeout: process.env.VUE_APP_CHAT_GATIMEOUT ?? 2500,

  // A cookie to track the last time startChat was called,
  // regardless of success. Used by UI implementations to
  // control things like deferred initialization.
  lastStartTimeCookieName: process.env.VUE_APP_CHAT_LASTSTARTCOOKIE ?? "nxChatLastStartTime",
};
